import { Box } from '@mui/material'
import React, { createContext, useContext, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'

interface GlobalFormActionsHostContextValue {
  element: HTMLDivElement | null
  setElement: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>
}

const GlobalFormActionsHostContext = createContext<GlobalFormActionsHostContextValue | null>(null)
GlobalFormActionsHostContext.displayName = 'GlobalFormActionsHostContext'

export const GlobalFormActionsProvider: React.FC = ({ children }) => {
  const [hostElement, setHostElement] = useState<HTMLDivElement | null>(null)
  const contextValue = useMemo(
    () => ({ element: hostElement, setElement: setHostElement }),
    [hostElement, setHostElement]
  )

  return <GlobalFormActionsHostContext.Provider value={contextValue}>{children}</GlobalFormActionsHostContext.Provider>
}

export const GlobalFormActionsHost = (): JSX.Element | null => {
  const host = useContext(GlobalFormActionsHostContext)

  if (!host) return null

  return (
    <Box
      data-testid="global-form-actions-host"
      ref={host.setElement}
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexShrink: 0,
        gap: 1,
        justifyContent: 'flex-end',
        mx: 1,
        '&:empty': {
          display: 'none',
          margin: 0,
        },
      }}
    />
  )
}

export const GlobalFormActionsPortal: React.FC = ({ children }) => {
  const host = useContext(GlobalFormActionsHostContext)

  if (!host) return <>{children}</>
  if (!host.element) return null

  return createPortal(children, host.element)
}
